package com.heelion.farmafreelance.ui

import androidx.compose.runtime.*

val LocalLanguage = staticCompositionLocalOf<String?> { null }

actual object LocalAppLocale {
    @Composable
    actual infix fun provides(value: String?): ProvidedValue<*> {
        return LocalLanguage provides value
    }
}
